module.exports = __webpack_public_path__ + "static/img/city-mob-red-ar-2.d2ce951.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/city-mob-red-ar-2.png
// module id = 1074
// module chunks = 173